module.exports = "\n<menu-layout class=\"surveys-page\" data-title=\"{{'SURVEYS' | translate}}\">\n\n\n\t<div class=\"surveys-page__actions\">\n\t\t<button class=\"btn btn-default\" ng-click=\"surveys.create()\"><span class=\"icon icon-plus\"></span> {{'ADD_SURVEY' | translate}}</button>\n\t</div>\n\n\t<custom-table\n\t\theaders=\"surveys.headers\"\n\t\tdata=\"surveys.surveys\"\n\t\tactive=\"surveys.active\"\n\t>\n\t\t<div class=\"no-result\">\n\t\t\t<h1>{{'NO_SURVEY' | translate}}</h1>\n\t\t\t<h4>{{'ADD_SURVEY_TUTO' | translate}}</h4>\n\t\t</div>\n\t</custom-table>\n\n\n</menu-layout>\n"


//////////////////
// WEBPACK FOOTER
// ./src/page/surveys/surveys.html
// module id = 531
// module chunks = 0